import { Box, Typography } from "@mui/material";

import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const Page404 = () => {
    useDocumentTitle("Not found");

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Typography variant="h1">404</Typography>
            <Typography variant="h6">Page Not Found</Typography>
        </Box>
    );
};

export default Page404;
